import * as api from '../../../clients/vorlagen';

import {Action} from '@ngrx/store';

export const POST_AUFGABEN_BENUTZER_BERECHTIGUNGEN_ENTFERNEN = '[VorlagenModul] PostAufgabenBenutzerBerechtigungenEntfernen laden';
export const POST_AUFGABEN_BENUTZER_BERECHTIGUNGEN_ENTFERNEN_AUSFUEHREN = '[VorlagenModul] PostAufgabenBenutzerBerechtigungenEntfernen ausführen';
export const POST_AUFGABEN_BENUTZER_BERECHTIGUNGEN_ENTFERNEN_ERFOLGREICH = '[VorlagenModul] PostAufgabenBenutzerBerechtigungenEntfernen laden erfolgreich';
export const POST_AUFGABEN_BENUTZER_BERECHTIGUNGEN_ENTFERNEN_FEHLER = '[VorlagenModul] PostAufgabenBenutzerBerechtigungenEntfernen Ladefehler';
export const POST_AUFGABEN_BENUTZER_BERECHTIGUNGEN_ENTFERNEN_NICHT_AUSGEFUEHRT = '[VorlagenModul] PostAufgabenBenutzerBerechtigungenEntfernen nicht ausgeführt (evtl. Offline)';


export class PostAufgabenBenutzerBerechtigungenEntfernenAction implements Action {
    readonly type = POST_AUFGABEN_BENUTZER_BERECHTIGUNGEN_ENTFERNEN;
        constructor(public aufgabenBenutzerIdsRequest: api.AufgabenBenutzerIdsRequest, public optPayload: any = null) {}
    }
export class PostAufgabenBenutzerBerechtigungenEntfernenAusfuehrenAction implements Action {
    readonly type = POST_AUFGABEN_BENUTZER_BERECHTIGUNGEN_ENTFERNEN_AUSFUEHREN;
        constructor(public aufgabenBenutzerIdsRequest: api.AufgabenBenutzerIdsRequest, public optPayload: any = null) {}
    }
export class PostAufgabenBenutzerBerechtigungenEntfernenErfolgreichAction implements Action {
    readonly type = POST_AUFGABEN_BENUTZER_BERECHTIGUNGEN_ENTFERNEN_ERFOLGREICH;
        constructor(public aufgabenBenutzerIdsRequest: api.AufgabenBenutzerIdsRequest, public optPayload: any = null) {}
    }
export class PostAufgabenBenutzerBerechtigungenEntfernenFehlerAction implements Action {
    readonly type = POST_AUFGABEN_BENUTZER_BERECHTIGUNGEN_ENTFERNEN_FEHLER;
        constructor(public payload: any, public aufgabenBenutzerIdsRequest: api.AufgabenBenutzerIdsRequest, public optPayload: any = null) {}
    }
export class PostAufgabenBenutzerBerechtigungenEntfernenNichtAusgefuehrtAction implements Action {
    readonly type = POST_AUFGABEN_BENUTZER_BERECHTIGUNGEN_ENTFERNEN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type VorlagenCommandAufgabenBenutzerBerechtigungenEntfernenActions =
    PostAufgabenBenutzerBerechtigungenEntfernenAction
    | PostAufgabenBenutzerBerechtigungenEntfernenAusfuehrenAction
    | PostAufgabenBenutzerBerechtigungenEntfernenErfolgreichAction
    | PostAufgabenBenutzerBerechtigungenEntfernenFehlerAction
    | PostAufgabenBenutzerBerechtigungenEntfernenNichtAusgefuehrtAction
    ;
